const LOCALE = 'locale';

const AVAILABLE_LANGUAGES = ['de', 'it', 'fr'];
const DEFAULT_LANGUAGE = 'de';

const validateLanguageCode = languageCode => {
  return languageCode && AVAILABLE_LANGUAGES.includes(languageCode);
};

export const setLanguage = language => localStorage.setItem(LOCALE, language);

export const getLanguage = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang');
  const isValidLanguage = validateLanguageCode(lang);

  if (isValidLanguage) {
    setLanguage(lang);
    return lang;
  }

  return localStorage.getItem(LOCALE);
};

export const setDefaultLanguageWithReturn = () => {
  const { language } = navigator;
  const transformedLanguage = language && language.substring(0, 2);
  const locale = validateLanguageCode(transformedLanguage) ? transformedLanguage : DEFAULT_LANGUAGE;
  setLanguage(locale);
  return locale;
};
